import React, {Component, Fragment } from 'react';
import Helmet from 'react-helmet';

const initialState = {
  id: '',
  password: '',
  showPwd: false,
  dispPassKeyFlg: false,
  fillinId: '',
  errorMap: null,
  checkboxFlg: true
}

class Login extends Component {
  state = initialState;

  // 初期処理
  componentDidMount() {

    // 「オートログインチェックボックス」項目が画面に存在する場合、初期表示状態をtrueに設定する。
    if (document.getElementById('LB_form-checkbox-02')) {
      document.getElementById('LB_form-checkbox-02').checked = true;
    }
    this.setState({
      dispPassKeyFlg: this.props.dispPassKeyFlg,
      fillinId: this.props.fillinId
    })
  }

  // [ログイン]ボタン押下時処理
  login = async () => {

    // ID・パスワードの取得
    const { id, password } = this.state;
    let tempId;
    if (this.props.autoLoginStateFlg) {
      tempId = this.props.autoLoginId;
    }
    else {
      tempId = id;
    }

    // お得意様番号が7桁の場合は先頭に00でパディングして9桁で送信する
    let requestId;
    if (tempId && tempId.length === 7) {
      requestId = tempId.padStart(9, '00');
    }
    else {
      requestId = tempId;
    }

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');

    // アクショントークン格納変数の宣言
    let actionToken = null;
    // セッショントークン格納変数の宣言
    let sessionToken;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("login_idpwd", { correlationId: l_sid, claimedUserId: requestId });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // SDK呼出(セッショントークン取得)
    try {
      // セッショントークン取得
      sessionToken = await window.tsPlatform.drs.getSessionToken();
    } catch (e) {
    }

    // 低レベルセッション作成フラグ」変数を定義する
    let lowLevelSessionFlg;

    // 「低レベルセッション作成フラグ」に値を設定する
    if (document.getElementById('LB_form-checkbox-02')) {
      // オートログインチェックボックスの画面入力値を設定する
      lowLevelSessionFlg = document.getElementById('LB_form-checkbox-02').checked;
    }
    else {
      // 親コンポーネントから受け取った「オートログイン状態フラグ」の値を設定する
      lowLevelSessionFlg = this.props.autoLoginStateFlg;
    }

    // 親コンポーネントの共通ログインAPI呼出す処理を呼び出す
    const info={ ORG_ID: 'jmbNo', ID:tempId, PWD:password, LowLevelSessionFlg:lowLevelSessionFlg, ACTION_TOKEN:actionToken, SESSION_TOKEN:sessionToken };
    // メソッドを呼出す
    this.props.loginMethod(info);
  }

  // 画面入力項目クリア処理
  componentDidUpdate(prevProps, prevState) {

    // 現在のエラーマップは前のエラーマップを比較し、更新された場合、画面入力項目をクリアする
    if (this.props.errMap !== prevProps.errMap || this.state.errorMap !== prevState.errorMap) {
      // パスワードをクリアする
      this.setState({ password: '' });
    }

    // 「オートログインチェックボックス」項目が画面に存在する場合、初期表示状態をtrueに設定する。
    if (this.state.dispPassKeyFlg !== prevState.dispPassKeyFlg) {
      if (document.getElementById('LB_form-checkbox-02')) {
        document.getElementById('LB_form-checkbox-02').checked = this.state.checkboxFlg;
      }
    }
    if (this.props.dispPassKeyFlg !== prevProps.dispPassKeyFlg) {
      this.setState({ dispPassKeyFlg: this.props.dispPassKeyFlg });
    }
  }

  // [ログアウト]ボタン押下時処理
  logout = e => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    this.props.logoutMethod();
  }

  // パスワードマスク表示切替処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // SNSログインボタン押下時処理
  snsLogin = async (sns) =>{

    // 外部サイトID・アクションタイプを決定する
    let snsID;
    let actionType;
    if(sns===0){
      snsID = process.env.REACT_APP_SNSID_GOOGLE;
      actionType = "login_sns_google";
    }else if(sns===1){
      snsID = process.env.REACT_APP_SNSID_YAHOO;
      actionType = "login_sns_yahoo";
    }else if(sns===2){
      snsID = process.env.REACT_APP_SNSID_LINE;
      actionType = "login_sns_line";
    }

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken;
    // セッショントークン格納変数の宣言
    let sessionToken;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent(actionType, { correlationId: l_sid });

            // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // SDK呼出(セッショントークン取得)
    try {
      // セッショントークン取得
      sessionToken = await window.tsPlatform.drs.getSessionToken();
    } catch (e) {
    }

    // セッションストレージにSNSログイン情報を設定する
    sessionStorage.setItem('SNSLOGIN', 'True');

    // ローカルストレージに画面デザイン、画面表示言語を設定する
    if(sns===2){
      localStorage.setItem('design',sessionStorage.getItem('design'));
      localStorage.setItem('lang',sessionStorage.getItem('lang'));
    }

    // 親コンポーネント（共通ログイン処理）のlogin前処理を呼び出す
    const info = {
      AUTH_TYPE: process.env.REACT_APP_AUTH_TYPE,
      snsid: snsID,
      ACTION_TOKEN: actionToken,
      SESSION_TOKEN:sessionToken
    };
    this.props.snslogin(info);
  }

  // 「ログイン」（パスキー認証）ボタン押下処理
  toPasskeyLogin = () => {
    // IDの取得
    const { id } = this.state;

    this.setState({
      dispPassKeyFlg: true,
      fillinId:id,
      showPwd: false
    });

    // エラーマップをクリア
    delete this.props.errMap.ERROR;

    // ページ先頭に遷移する
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  // パスワードでログインする方はこちらボタン押下処理
  toIPLogin = async () => {
    this.setState({
      errorMap: null
    });
    // IDの取得
    const { id } = this.state;

    // エラーマップをクリア
    delete this.props.errMap.ERROR;

    // 親コンポーネント（共通ログイン処理）のlogin前処理を呼び出す
    const info = {
      AUTH_TYPE: 'AUTH_THREEKEY',
      changeAuthTypeFlg: true,
      fillinId: id
    };
    this.props.snslogin(info);

    // ページ先頭に遷移する
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  // ログインボタン押下処理(パスキー認証)
  passkeyLogin = async () => {

    // IDの取得
    const { id } = this.state;
    let tempId;
    if (this.props.autoLoginStateFlg) {
      tempId = this.props.autoLoginId;
    }
    else {
      tempId = id;
    }

    // お得意様番号が7桁の場合は先頭に00でパディングして9桁で送信する
    let requestId;
    if (tempId && tempId.length === 7) {
      requestId = tempId.padStart(9, '00');
    }
    else {
      requestId = tempId;
    }

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');

    // アクショントークン格納変数の宣言
    let actionToken;
    // セッショントークン格納変数の宣言
    let sessionToken;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("login_passkey", { correlationId: l_sid, claimedUserId: requestId });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // SDK呼出(セッショントークン取得)
    try {
      // セッショントークン取得
      sessionToken = await window.tsPlatform.drs.getSessionToken();
    } catch (e) {
    }

    // 低レベルセッション作成フラグ」変数を定義する
    let lowLevelSessionFlg;

    // 「低レベルセッション作成フラグ」に値を設定する
    if (document.getElementById('LB_form-checkbox-02')) {
      // オートログインチェックボックスの画面入力値を設定する
      lowLevelSessionFlg = document.getElementById('LB_form-checkbox-02').checked;
    }
    else {
      // 親コンポーネントから受け取った「オートログイン状態フラグ」の値を設定する
      lowLevelSessionFlg = this.props.autoLoginStateFlg;
    }

    // バリデーションチェック
    if (requestId === '') {
      let messageList = JSON.parse(sessionStorage.getItem('messageList'));
      this.setState({ errorMap: { ERROR: messageList.loginPasskey.M013_errorMessage001, errorId: 'id' } });
      // エラーマップをクリア
      delete this.props.errMap.ERROR;
      // エラーメッセージ表示領域に遷移する
      window.location = "#JS_error";
      return;
    }

    // 親コンポーネント（共通ログイン処理）のlogin前処理を呼び出す
    const Fs2AuthenticationRequest = { username: requestId };
    const info = {
      AUTH_TYPE: process.env.REACT_APP_AUTH_FS2,
      LowLevelSessionFlg: lowLevelSessionFlg,
      ACTION_TOKEN: actionToken,
      SESSION_TOKEN: sessionToken,
      Fs2AuthenticationRequest: JSON.stringify(Fs2AuthenticationRequest)
    };
    this.props.snslogin(info);

  }

  // オートログインチェック状態保存
  setCheckboxFlg = (checked) =>{
    this.setState({checkboxFlg:checked});
  }

  // Enterキー押下時処理
  handleKeyPress = e => {
    if(e.key === "Enter"){
      e.preventDefault();
      this.login();
    }
  }

  // Enterキー押下時処理(パスキー認証)
  handleKeyPressPasskey = e => {
    if(e.key === "Enter"){
      e.preventDefault();
      this.passkeyLogin();
    }
  }

  // 画面表示処理
  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // RP別デザインを取得する
    let designI01; // オートログインデザイン
    let designI02; // JALカードデザイン（Rトースター）
    let designI03; // 提携社用デザイン
    let designI04; // SNSログインデザイン
    let designI05; // LINEログイン非表示デザイン
    let designI06; // JOHNデザイン
    // デザイン定義ファイルを読み込み
    let designJson = require('../jsonFile/design.json');

    // 画面、項目ID、デザイン値に該当するデザインファイルを読み込む
    Object.keys(designJson.login.I01).forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI01 = require('./design/' + designJson.login.I01[data]);
      }
    });
    Object.keys(designJson.login.I02).forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI02 = require('./design/' + designJson.login.I02[data]);
      }
    });
    Object.keys(designJson.login.I03).forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI03 = require('./design/' + designJson.login.I03[data]);
      }
    });
    designJson.login.I04.forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI04 = true;
      }
    });
    designJson.login.I05.forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI05 = true;
      }
    });
    Object.keys(designJson.login.I06).forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI06 = require('./design/' + designJson.login.I06[data]);
      }
    });

    // JOHNデザインの画面表示
    if (designI06 && !this.state.dispPassKeyFlg) {
      return (
        designI06.getDesign({
          design: sessionStorage.getItem('design'),
          loading: this.props.loading,
          messageListLogin: messageList.login,
          errMap: this.props.errMap,
          state: this.state,
          webAuthnFlg: this.props.webAuthnFlg,
          toPasskeyLoginMethod: this.toPasskeyLogin,
          autoLoginStateFlg: this.props.autoLoginStateFlg,
          autoLoginId: this.props.autoLoginId,
          handleChangeMethod: this.handleChange,
          swhichPwdShowMethod: this.swhichPwdShow,
          handleKeyPressMethod: this.handleKeyPress,
          loginMethod: this.login
        })
      );
    }
    // JALデザインの画面表示
    else if(!this.state.dispPassKeyFlg){
      return (
        <section className="content">
          {(designI02) ?
            <Helmet
              title={messageList.login.M001_browserTitle_jci} >
            </Helmet> :
            <Helmet
              title={messageList.login.M001_browserTitle} >
            </Helmet>}

          { // Loadingモーダル表示
            this.props.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
          }

          { // LINEタブ遷移モーダル表示
            this.props.tabChangeFlg &&
            <div id="tabChange" className="tab-change-modal">
              <span className="tab-change-message">
                リダイレクトしています…<br></br>
                終了後は画面を閉じてください<br></br>
                <br></br>
                Redirecting…<br></br>
                Please close this screen when finished.
              </span>
            </div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            {(designI02) ?
              <h1 className="ds-heading__title">{messageList.login.M002_pageTitle_jci}</h1> :
              <h1 className="ds-heading__title">{messageList.login.M002_pageTitle}</h1>}
          </div>

          <div className="contentInner">
            {/* 提携社デザイン表示エリア */}
            {(designI03) && designI03.getDesign(messageList.login)}
            {/* 提携社デザイン表示エリア */}

            <div id="JS_error">
              { // エラーメッセージ表示
                (this.props.errMap && this.props.errMap.ERROR) &&
                <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.login.M003_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.login.M004_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.props.errMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
              }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner formPanel__inner--split">
                {/* 画面項目表示部 */}
                <div className="ds-heading ds-heading--sm u-al-center--pc">
                  <h2 className="ds-heading__title">{messageList.login.M075_passwordTitle}</h2>
                </div>

                <form name="form">
                  <div className="formList">
                    {/* お得意様番号（通常入力） */}
                    {
                      (!this.props.autoLoginStateFlg) &&
                      <div className="formList__line">
                        <div className="formWrap">
                          <label className="formLabel" htmlFor="LB_input-jmbnumber-1">
                            <span className="formLabel__text">{messageList.login.M005_id}</span>
                          </label>
                          <input type="text" id="LB_input-jmbnumber-1" name="id"
                            className={this.props.errMap && this.props.errMap.errorId === 'id' ? "ds-textfield is-error" : "ds-textfield"}
                            maxLength="9" inputMode="numeric" autoComplete="username" required
                            aria-invalid={this.props.errMap && this.props.errMap.errorId === 'id' ? "true" : "false"}
                            aria-describedby="LB_input-jmbnumber-1-helper"
                            defaultValue={this.state.fillinId} value={this.state.id} onChange={this.handleChange} />
                          <span className="helperText" id="LB_input-jmbnumber-1-helper">{messageList.login.M091_helperText}</span>
                        </div>
                      </div>
                    }
                    {/* お得意様番号（オートログイン時 読み取り専用） */}
                    {
                      (this.props.autoLoginStateFlg) &&
                      <div className="formList__line">
                        <div className="formWrap">
                          <label className="formLabel" htmlFor="LB_input-jmbnumber-2">
                            <span className="formLabel__text">{messageList.login.M005_id}</span>
                          </label>
                          <input type="text" id="LB_input-jmbnumber-2"
                            className="ds-textfield"
                            maxLength="9" inputMode="numeric" autoComplete="username" required
                            aria-invalid="false" aria-describedby="LB_input-jmbnumber-2-helper"
                            readOnly defaultValue={this.props.autoLoginId} tabIndex="-1" />
                          <span className="helperText" id="LB_input-jmbnumber-2-helper">{messageList.login.M091_helperText}</span>
                        </div>
                      </div>
                    }

                    {/* パスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password">
                          <span className="formLabel__text">{messageList.login.M006_password}</span>
                        </label>
                        <input type={this.state.showPwd ? "text" : "password"} id="LB_input-password" name="password"
                          className={this.props.errMap && this.props.errMap.errorId === 'password' ? "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256" required autoComplete="current-password"
                          aria-invalid={this.props.errMap && this.props.errMap.errorId === 'password' ? "true" : "false"}
                          value={this.state.password} onChange={this.handleChange}
                          onKeyPress={this.handleKeyPress} />

                        {/* パスワードを表示する */}
                        <label className="ds-checkbox">
                          <input className="ds-checkbox__input" type="checkbox" name="checkPassword"
                            aria-controls="LB_input-password" onChange={this.swhichPwdShow} />
                          <span className="ds-checkbox__partsWrap">
                            <span className="ds-checkbox__parts" role="presentation"></span>
                            <span className="ds-checkbox__text">{messageList.login.M008_showPassword}</span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.login}>
                          <span className="ds-button__label">{messageList.login.M011_login}</span>
                        </button>
                      </div>

                      {/* ログイン状態を保持する */}
                      {(designI01 && !this.props.snsHidden) && designI01.getDesign({M012_remPassword: messageList.loginPasskey.M005_remPassword, setCheckboxFlg: this.setCheckboxFlg})}
                    </div>
                  </div>

                  {/* パスワードリセットリンク */}
                  <div className="textLinkList u-mt-32">
                    <a href={"./pwd_reset?design=" + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang')}
                      className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      {messageList.login.M010_resetPassword}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                    <a href={messageList.login.M074_noticeUrl006}
                      className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      {messageList.login.M023_notice010}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                  </div>
                </form>
              </div> {/* /formPanel__inner */}

              <div className="formPanel__inner formPanel__inner--split">
                {/* パスキー認証 */}
                <div className="ds-heading ds-heading--sm u-al-center--pc">
                  <h2 className="ds-heading__title">{messageList.login.M076_passkeyTitle}</h2>
                </div>
                <p className="ds-text ds-text--md ds-text--note">{messageList.login.M077_notice024}</p>
                <a href={messageList.login.M084_noticeUrl007}
                  className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                  target="_blank" rel="noopener noreferrer">
                  {messageList.login.M080_notice026}&nbsp;
                  <span className="ds-textLink__icon">
                    <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                      <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                    </svg>
                  </span>
                </a>

                <div className="u-mt-24 u-mb-32 u-al-center">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/icon_passkey.svg`} className="u-img-full" alt="" aria-hidden="true" />
                </div>

                <div className="buttonLayout">
                  <div className="buttonWrap buttonWrap--center">
                    {(!this.props.webAuthnFlg) &&
                      <div className="buttonWrap__text">
                        <p className="ds-text u-fz-12">{messageList.login.M078_notice025}</p>
                      </div>
                    }
                    <div className={this.props.webAuthnFlg ? "ds-button ds-button--secondary ds-button--large" : "ds-button ds-button--secondary ds-button--large is-disabled"}>
                      <button
                        className={this.props.webAuthnFlg ? "ds-button__trigger" : "ds-button__trigger ds-button__trigger--disabled"}
                        type="button" disabled={!this.props.webAuthnFlg} onClick={this.toPasskeyLogin}>
                        <span className="ds-button__label">{messageList.login.M079_login}</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* SNSログイン */}
                {
                  (!this.props.snsHidden && designI04) &&
                  <Fragment>
                    <div className="ds-heading ds-heading--sm u-mt-40--sp u-mt-48--pc u-al-center--pc">
                      <h2 className="ds-heading__title">{messageList.login.M044_snsTitle}</h2>
                    </div>
                    <ul className="u-d-grid u-gap-20 u-al-center">
                      {/* googleログイン */}
                      {(!this.props.webViewFlag) &&
                        <li>
                          <button type="button" className="imgButton imgButton--google" onClick={() => this.snsLogin(0)}>
                            {(sessionStorage.getItem('lang') === "ja") ?
                              <img src={`${process.env.PUBLIC_URL}/assets/img/btn_google.svg`} alt={messageList.login.M045_snsGoogle} />
                              :
                              <img src={`${process.env.PUBLIC_URL}/assets/img/btn_google_en.svg`} alt={messageList.login.M045_snsGoogle} />
                            }
                          </button>
                        </li>
                      }
                      {/* yahooログイン */}
                      <li>
                        <button type="button" className="imgButton imgButton--yahoo" onClick={() => this.snsLogin(1)}>
                          {(sessionStorage.getItem('lang') === "ja") ?
                            <img src={`${process.env.PUBLIC_URL}/assets/img/btn_yahoojapan.svg`} alt={messageList.login.M046_snsYahoo} />
                            :
                            <img src={`${process.env.PUBLIC_URL}/assets/img/btn_yahoojapan_en.svg`} alt={messageList.login.M046_snsYahoo} />
                          }
                        </button>
                      </li>
                      {/* LINEログイン */}
                      {(!designI05) &&
                        <li>
                          <button type="button" className="imgButton imgButton--line" onClick={() => this.snsLogin(2)}>
                            {(sessionStorage.getItem('lang') === "ja") ?
                              <img src={`${process.env.PUBLIC_URL}/assets/img/btn_line.svg`} alt={messageList.login.M053_snsLine} />
                              :
                              <img src={`${process.env.PUBLIC_URL}/assets/img/btn_line_en.svg`} alt={messageList.login.M053_snsLine} />
                            }
                          </button>
                        </li>
                      }
                    </ul>

                    <div className="u-mt-32">
                      <a href={messageList.login.M072_noticeUrl004}
                        className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                        target="_blank" rel="noopener noreferrer">
                        {messageList.login.M047_snsNotice001}&nbsp;
                        <span className="ds-textLink__icon">
                          <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                          </svg>
                        </span>
                      </a>
                      <p className="ds-text">{messageList.login.M048_snsNotice002}</p>
                      <a href={messageList.login.M073_noticeUrl005}
                        className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                        target="_blank" rel="noopener noreferrer">
                        {messageList.login.M049_snsNotice003}&nbsp;
                        <span className="ds-textLink__icon">
                          <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                          </svg>
                        </span>
                      </a>
                    </div>
                  </Fragment>
                }
              </div> {/* /formPanel__inner */}
            </div>
          </div>

          {/* Rトースターエリア */}
          {(designI02) && designI02.getDesign()}
          {/* Rトースターエリア */}

          {/* リンク表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.login.M013_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              {
                (this.props.autoLoginStateFlg) &&
                <li className="ds-listText__item">{messageList.login.M085_notice028}<br />
                  <a href="#" className="ds-textLink ds-textLink--chevronRight u-fw-bold u-mt-8" onClick={this.logout}>
                    {messageList.login.M086_logout}&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </li>
              }
              {
                (this.props.guestUrl) &&
                <li className="ds-listText__item">{messageList.login.M087_notice029}<br />
                  <a href={this.props.guestUrl} className="ds-textLink ds-textLink--chevronRight u-fw-bold u-mt-8">
                    {messageList.login.M088_guest}&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </li>
              }
              <li className="ds-listText__item">{messageList.login.M022_notice009}</li>
            </ul>
          </div>
        </section>
      );
    }
    // ログイン画面(パスキー認証)の画面表示
    else{
      return (
        <section className="content">
          {(sessionStorage.getItem('design') !== "JH004N") ?
            <Helmet
              title={messageList.loginPasskey.M001_browserTitle} >
            </Helmet>
            :
            <Helmet
              title={messageList.loginPasskey.M001_browserTitle_john_report} >
            </Helmet>
          }

          { // Loadingモーダル表示
            this.props.loading &&
              <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            {(sessionStorage.getItem('design') !== "JH004N") ?
              <h1 className="ds-heading__title">{messageList.loginPasskey.M002_pageTitle}</h1>
              :
              <h1 className="ds-heading__title">{messageList.loginPasskey.M002_pageTitle_john_report}</h1>
            }
          </div>

          <div className="contentInner">
            {/* パスキー事前設定リンク */}
            {(sessionStorage.getItem('design') !== "JH001N" && sessionStorage.getItem('design') !== "JH004N") &&
            <a href={messageList.loginPasskey.M008_noticeUrl001}
              className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              {messageList.loginPasskey.M010_notice001}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.loginPasskey.M009_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>}

            <div id="JS_error">
              { // エラーメッセージ表示
                (this.props.errMap && this.props.errMap.ERROR) ?
                <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.loginPasskey.M011_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.loginPasskey.M012_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.props.errMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
                :
                // エラーメッセージ表示(自画面での判定用)
                (this.state.errorMap && this.state.errorMap.ERROR) &&
                <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.loginPasskey.M011_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.loginPasskey.M012_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.state.errorMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
              }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">

                  {/* 画面項目表示部 */}
                  {/* お得意様番号 */}
                  {
                    (!this.props.autoLoginStateFlg) &&
                    <div className="formWrap">
                      <label className="formLabel" htmlFor="LB_input-jmbnumber">
                        <span className="formLabel__text">{messageList.login.M005_id}</span>
                      </label>
                      <input type="text" id="LB_input-jmbnumber" name="id"
                        className={this.state.errorMap && this.state.errorMap.errorId === 'id' ? "ds-textfield is-error" : "ds-textfield"}
                        maxLength="9" inputMode="numeric" autoComplete="username" required
                        aria-invalid={this.state.errorMap && this.state.errorMap.errorId === 'id' ? "true" : "false"}
                        aria-describedby="LB_input-jmbnumber-helper"
                        defaultValue={this.state.fillinId} value={this.state.id} onChange={this.handleChange} onKeyPress={this.handleKeyPressPasskey} />
                      <span className="helperText" id="LB_input-jmbnumber-helper">{messageList.loginPasskey.M019_helperText}</span>
                    </div>
                  }
                  {
                    (this.props.autoLoginStateFlg) &&
                    <div className="formWrap">
                      <label className="formLabel" htmlFor="LB_input-jmbnumber">
                        <span className="formLabel__text">{messageList.login.M005_id}</span>
                      </label>
                      <input type="text" id="LB_input-jmbnumber"
                        className="ds-textfield"
                        maxLength="9" inputMode="numeric" autoComplete="username" required
                        aria-invalid="false" aria-describedby="LB_input-jmbnumber-helper"
                        readOnly defaultValue={this.props.autoLoginId} tabIndex="-1" />
                      <span className="helperText" id="LB_input-jmbnumber-helper">{messageList.loginPasskey.M019_helperText}</span>
                    </div>
                  }

                  <div className="u-mt-24 u-mb-32 u-al-center">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icon_passkey.svg`} className="u-img-full u-w-full" alt="" aria-hidden="true" />
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.passkeyLogin}>
                          <span className="ds-button__label">{messageList.loginPasskey.M004_login}</span>
                        </button>
                      </div>

                      {/* ログイン状態を保持する */}
                      {(designI01 && !this.props.snsHidden) && designI01.getDesign({M012_remPassword: messageList.loginPasskey.M005_remPassword, setCheckboxFlg: this.setCheckboxFlg})}
                    </div>
                  </div>
                </form>

                {/* パスワードでログインするボタン */}
                <div className="buttonLayout">
                  <div className="buttonWrap buttonWrap--center">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <button className="ds-button__trigger" type="button" onClick={this.toIPLogin}>
                        <span className="ds-button__label">{messageList.loginPasskey.M006_passLogin}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.loginPasskey.M007_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              {(sessionStorage.getItem('design') !== "JH001N" && sessionStorage.getItem('design') !== "JH004N") &&
              <Fragment>
                {
                  (this.props.autoLoginStateFlg) &&
                  <li className="ds-listText__item">{messageList.loginPasskey.M014_notice002}<br />
                    <a href="#" className="ds-textLink ds-textLink--chevronRight u-fw-bold u-mt-8" onClick={this.logout}>
                      {messageList.loginPasskey.M015_logout}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                        </svg>
                      </span>
                    </a>
                  </li>
                }
                {
                  (this.props.guestUrl) &&
                  <li className="ds-listText__item">{messageList.loginPasskey.M016_notice003}<br />
                    <a href={this.props.guestUrl} className="ds-textLink ds-textLink--chevronRight u-fw-bold u-mt-8">
                      {messageList.loginPasskey.M017_guest}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                        </svg>
                      </span>
                    </a>
                  </li>
                }
                <li className="ds-listText__item">{messageList.loginPasskey.M018_notice004}</li>
              </Fragment>
              }
              {(sessionStorage.getItem('design') === "JH001N" || sessionStorage.getItem('design') === "JH004N") &&
                <Fragment>
                  <li className="ds-listText__item">
                    <a href={messageList.loginPasskey.M008_noticeUrl001}
                      className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      {messageList.loginPasskey.M010_notice001}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.loginPasskey.M009_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                  </li>
                  <li className="ds-listText__item">{messageList.login.M018_notice005}<br />
                    {messageList.login.M019_notice006}
                  </li>
                  <li className="ds-listText__item">{messageList.login.M020_notice007}<br />
                    <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      {messageList.login.M021_notice008}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                  </li>
                  <li className="ds-listText__item">{messageList.login.M061_notice016}
                    <a href="https://www.jal.co.jp/jalonline/policy/browser.html" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      &nbsp;{messageList.login.M062_notice017}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                    &nbsp;{messageList.login.M063_notice018}
                  </li>
                  <li className="ds-listText__item">{messageList.login.M064_notice019}
                    <a href="https://www.jal.co.jp/jalonline/rule/security.html" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      &nbsp;{messageList.login.M065_notice020}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                    &nbsp;{messageList.login.M066_notice021}
                  </li>
                  <li className="ds-listText__item">{messageList.login.M022_notice009}</li>
                  <li className="ds-listText__item">{messageList.login.M067_notice022}<br />
                    <a href="https://www.jal.co.jp/cgi-bin/jal/jmb/enroll/index.cgi" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                      target="_blank" rel="noopener noreferrer">
                      {messageList.login.M068_notice023}&nbsp;
                      <span className="ds-textLink__icon">
                        <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.login.M026_newWindowIcon}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                        </svg>
                      </span>
                    </a>
                  </li>
                </Fragment>
              }
            </ul>
          </div>

        </section>
      );
    }
  }
}

export default Login
